import { Routes } from '@angular/router';

export const BusinessModuleRoutes: Routes = [
    {
        path: 'intelligencemgmt',
        loadChildren: () =>
            import('./intelligencemgmt-ui/ui-intelligencemgmt.module').then(
                (m) => m.UiIntelligencemgmtModule
            ),
    },
    {
        path: 'ics-declaration',
        loadChildren: () =>
            import('./declaration-ui/ui-ics-declaration.module').then(
                (m) => m.UiIcsDeclarationModule
            ),
    },

    {
        path: 'customs-valuation',
        loadChildren: () =>
            import('./valuation-ui/ui-customs-valuation.module').then(
                (m) => m.UiCustomsValuationModule
            ),
    },
    {
        path: 'work-list-mgmt',
        loadChildren: () =>
            import('./worklist-ui/ui-work-list-mgmt.module').then(
                (m) => m.UiWorkListMgmtModule
            ),
    },
    {
        path: 'user-mgmt',
        loadChildren: () =>
            import('./usermgmt-ui/ui-user-mgmt.module').then(
                (m) => m.UiUserMgmtModule
            ),
    },
    {
        path: 'tariff',
        loadChildren: () =>
            import('./tariff-ui/ui-tariff.module').then(
                (m) => m.UiTariffModule
            ),
    },

    {
        path: 'admin-rdm',
        loadChildren: () =>
            import('./systemadmin-ui/ui-systemadmin.module').then(
                (m) => m.UiSystemadminModule
            ),
    },

    {
        path: 'reports',
        loadChildren: () =>
            import('./reports-ui/ui-reports.module').then(
                (m) => m.UiReportsModule
            ),
    }
]